export const ORDER_VERSION = {
  V2: 2,
  V1: 1,
};

const ORDER_RECEIPT_STATUS = {
  INIT: "init", // Chờ xử lí
  IN_PROGRESS: "in_progress", // Chờ thanh toán
  FINAL_SUCCESS: "final_success", // Thành công
  FINAL_RETURN: "final_return", // Hoàn
  FINAL_CANCEL: "final_cancel", // Hủy
  FINAL_FAILED: "final_failed", // Thất bại
};
export const ORDER_RECEIPT_STATUS_MAP = [
  {
    value: ORDER_RECEIPT_STATUS.INIT,
    text: "Chờ xử lý",
    styleClass: "primary",
  },
  {
    value: ORDER_RECEIPT_STATUS.IN_PROGRESS,
    text: "Chờ thanh toán",
    styleClass: "primary",
  },
  {
    value: ORDER_RECEIPT_STATUS.FINAL_SUCCESS,
    text: "Thành công",
    styleClass: "success",
  },
  {
    value: ORDER_RECEIPT_STATUS.FINAL_RETURN,
    text: "Hoàn",
  },
  {
    value: ORDER_RECEIPT_STATUS.FINAL_CANCEL,
    text: "Hủy",
  },
  {
    value: ORDER_RECEIPT_STATUS.FINAL_FAILED,
    text: "Thất bại",
  },
];
export const PRODUCT_TRIAL_TYPE = {
  SKU_DUO: "sku_duo",
  SKU_TUTOR: "sku_tutor",
  SKU_COMBO: "sku_combo",
};
export const ORDER_DEPOSIT_TYPE = 1;
export const ORDER_FINISH_TYPE = 2;
export const PACKAGE_FEE = {
  GIA_SU: 1,
  TU_HOC: 2,
};
const GV_VIETNAM = 1;
const GV_NATIVE = 2;
const GV_PHILIPPIN = 3;
export const LOAI_GIAOVIEN = [
  {
    id: GV_VIETNAM,
    name: "Việt Nam",
  },
  {
    id: GV_NATIVE,
    name: "Native",
  },
  {
    id: GV_PHILIPPIN,
    name: "Philippin",
  },
];
export const SUBJECTS_SORT_CLASS = [
  {
    id: 5,
    code: "TA",
    name: "TIẾNG ANH",
  },
  {
    id: 1,
    code: "TOAN",
    name: "TOÁN",
  },
  {
    id: 15,
    code: "VAN",
    name: "NGỮ VĂN",
  },
];
